<template>
  <div class="all-title-wrapper">

    <!-- 失活的组件将会被缓存！-->
    <keep-alive>
      <component
        v-bind:is="currentComponentName"
        :name="titleName"
        :theme="titleTheme"
        :type="moduleType"
        :width="width"
      ></component>
    </keep-alive>

    <!-- 功能按钮们 -->
    <div
      v-if="!openResumeError && !currentInfo.operation"
      class="title-operate-icon"
      :class="{'left-form-icon': cvDetail.format_info.top_format === 'left_form'}"
    >
      <!-- 添加按钮 -->
      <el-tooltip effect="dark" content="添加" placement="top"
      v-if="showBtnData.showBtnFlag &&
            moduleType !== 'skill_list' &&
            moduleType !== 'personal_summary' &&
            moduleType !== 'extras'" >
        <div class="icon-item add-icon" @click.stop="showBtnData.callback">
          <i class="iconfont icontianjia1"></i>
        </div>
      </el-tooltip>

      <!-- 排序 -👆 -->
      <el-tooltip effect="dark" content="上移" placement="top">
        <div class="icon-item sort-icon sort-icon-prev" :class="index===0 ? 'disabled' : ''" @click.stop="sortPrev()">
          <i class="iconfont iconshangyi1"></i>
        </div>
      </el-tooltip>
      <!-- 排序 -👇 -->
      <el-tooltip effect="dark" content="下移" placement="top">
        <div class="icon-item sort-icon sort-icon-next" :class="index=== sPosition.length-1 ? 'disabled' : ''" @click.stop="sortNext()">
          <i class="iconfont iconxiayi1"></i>
        </div>
      </el-tooltip>

      <!-- 删除按钮 -->
      <el-tooltip effect="dark" content="删除" placement="top" >
        <div class="icon-item delete-icon" @click.stop="deleteModule()">
          <i class="iconfont iconshanchu4"></i>
        </div>
      </el-tooltip>
    </div>

  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import api from '@/api'

import defaultTitle from './titleDefault'
import stripTitle from './titleStrip'
import tagTitle from './titleTag'
import iconTitle from './titleIcon'
import { cvMixin, dealCvDataMixin } from '@/assets/js/mixins'


export default {
  mixins: [ cvMixin, dealCvDataMixin ],
  props: {
    // 当前模块数据
    item: {
      type: Object,
      default: () => {}
    },
    // 当前模块坐标
    index: {
      type: Number,
      default: 0
    },
    // 所有模块数据
    sPosition: {
      type: Array,
      default: () => []
    },
    // 标题类型
    titleType: {
      type: String,
      default: 'default'
    },
    // 标题名
    titleName: {
      type: String,
      default: ''
    },
    // 标题主题色
    titleTheme: {
      type: String,
      default: '#404040'
    },
    // 模块类型
    moduleType: {
      type: String,
      default: ''
    },
    // 按钮数据
    showBtnData: {
      type: Object,
      default: {
        showBtnType: '', // 按钮类型
        showBtnText: '', // 按钮文本
        showBtnIcon: '', // 按钮 iconfont
        showBtnFlag: false, // 控制按钮显示隐藏
        callback: null
      }
    },
    width: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      listMenu: [], // 现有的模块
      extrasList:['certificate', 'interest', 'language', 'other', 'skill' ], //其他模块标题
    }
  },
  components: {
    defaultTitle,
    stripTitle,
    tagTitle,
    iconTitle
  },
  created () {
    this.listMenu = JSON.parse(JSON.stringify(this.menuList))
    // 获取已经未选中的模块
    // this.getFilterModule();
  },
  watch:{
    menuList: function (val) {
      this.listMenu = JSON.parse(JSON.stringify(this.menuList))
    }
  },
  computed: {
    ...mapState('editor', ['cvToken', 'cvDetail', 'openResumeError', 'currentInfo' ]),
    ...mapState('manage', ['menuList', 'editModuleData', 'moduleList', 'reloadMenuList']),
    ...mapState('experience', ['backUpExperienceList', 'experienceList', 'currentExperienceType', 'experienceTitleList', 'showManageAddGuide']),
    currentComponentName () {
      return `${this.titleType}Title`
    }
  },
  methods:{
    ...mapMutations('editor',['setCvDetail', 'setModuleData', 'updateCommonIndex']),
    ...mapActions('editor', ['getCheckData']),
    ...mapMutations('experience',['updateExperienceList', 'updateBackUpExperienceList']),
    ...mapMutations('manage',['setMenuList', ]),
    ...mapActions('manage',['getMenuList', 'getFilterModule']),
    // 删除模块
    deleteModule() {
      let data = {
        id: this.item.id,
        info_ids: [],
        key: this.item.id,
        sections_position: this.item,
        type: this.item.type,
      }
      console.log('delete', this.item, data, this.index);
      const alertData = {
        show: true,
        type: 'message',
        messageTitle: '删除提示',
        showCancelButton: true, //取消按钮
        showConfirmButton: true, // 确定按钮
        confirmButtonText: '取消',
        cancelButtonText: '删除',
        cancelButtonClass: 'cvs-edit-cancelButtonClass',
        confirmButtonClass: 'cvs-edit-confirmButtonClass',
        messageContent: `
        <p>删除内容将无法还原</p>
        <p style="color: #FF453E">确定要删除当前模块吗?</p>
      `,
        confirm: close => {
          close();
        },
        cancel: async close => {
          close();
          this.deleteModuleApi(data, this.index, close);
          console.log(111)
          this.resetEditState(true)
        }
      };
      this.$store.dispatch('app/setAlertData', alertData);
    },
    async deleteModuleApi(data, index, close) {
      let itemType = data.type ==='custom' ? data.id : data.type
      let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));
      let { sections_position, custom_sections_ids } = cvDetail.submodule_info;
      let experienceList = JSON.parse(JSON.stringify(this.experienceList));

      //如果是作品集，删除当前简历全部id
      if(itemType === 'opus'){
        //执行删除模块id
        let deletelist = [];
        cvDetail.submodule_info[itemType+'_ids'].forEach(item=>{
          deletelist.push(api.cvsEditor.deleteOpus(item, {}, {cv_token: this.cvToken}))
        })
        if(deletelist.length){
          await Promise.all(deletelist)
        }
      }
      if (itemType === 'works') {
        this.updateCommonIndex(-1)
      }

      //整理简历模块选中状态及选中数据相关id
      if( itemType === 'works' || itemType === 'orgs' || itemType === 'edus' || itemType === 'opus' ){
        cvDetail.submodule_info[itemType+'_ids'] = [];
      }else if (itemType === 'extras'){
        this.extrasList.forEach(key=>{
          cvDetail.submodule_info[key+'_id'] = null;
        })
      }else {
        custom_sections_ids = custom_sections_ids.filter(item => item != data.id);
      }

      sections_position = sections_position.filter(item => item && !((item.type === 'custom' && item.id === data.id) || (item.type !== 'custom' && item.type === data.type)));
      cvDetail.submodule_info.sections_position = sections_position;
      cvDetail.submodule_info.custom_sections_ids = custom_sections_ids;

      // 如果是模版，不请求接口
      if(cvDetail.basic_info.kind==='template' || cvDetail.basic_info.kind==='sample'){
        //整理经历库选中状态
        if(itemType === 'extras'){
          Object.keys(experienceList[itemType]).forEach(key=>{
            let item = experienceList[itemType][key];
            item.forEach(item=>{
              item.isSelect = false;
            })
          })
          // 判断是否属于当前编辑的模块
        }else{
          experienceList[itemType] && experienceList[itemType].forEach(item=>{
            item.isSelect = false;
          })
          // 判断是否属于当前编辑的模块
        }

        //同步简历信息到vuex中
        this.setCvDetail(cvDetail);

        this.getMenuList()

        //清除vuex中当前简历选择的模块
        this.setModuleData({ type: itemType, info:[] })

        //清除经历库里选中的状态
        this.updateExperienceList(experienceList)
        this.updateBackUpExperienceList(experienceList)
        return false;
      }
      //更新简历
      try {
        let data = {
          operation_type:'update_submodule_info',
          submodule_info: cvDetail.submodule_info
        }
        let res = {}
        if (window.location.href.includes('mentor')) {
          res = await api.cvsEditor.updatedMentorCvInfo(this.cvToken, data)
        } else {
          res = await api.cvsEditor.updatedCvInfo(this.cvToken, data)
        }
        if(res.code === 1000){

          //整理经历库选中状态
          if(itemType === 'extras'){
            Object.keys(experienceList[itemType]).forEach(key=>{
              let item = experienceList[itemType][key];
              item.forEach(item=>{
                item.isSelect = false;
              })
            })
          }else{
            experienceList[itemType] && experienceList[itemType].forEach(item=>{
              item.isSelect = false;
            })
          }
          console.log('deleteModuleApi=>>experienceList=>>>',experienceList)
          //同步简历信息到vuex中
          this.setCvDetail(cvDetail);

          //整理当前模块管理选中数据
          let listMenu = this.listMenu.filter(item=> !( item.id ===itemType || item.key ===itemType || item.type ===itemType ) )
          this.listMenu = listMenu;
          //同步已选模块数据
          this.setMenuList(listMenu);

          setTimeout(async () => {
            await this.getCheckData({ needDealCheck: false, clickCheck: false })
          },100)

          //更新未选择模块
          this.getFilterModule();

          //清除vuex中当前简历选择的模块
          this.setModuleData({ type: itemType, info:[] })

          //清除经历库里选中的状态
          this.updateExperienceList(experienceList)
          this.updateBackUpExperienceList(experienceList)

          this.$message.success('更新成功');
        }else{
          this.$message.error(res.message);
        }
      } catch (error) {
        console.log('error=>>',error)
        this.$message.error('更新失败');
      }

    },

    // 修改排序更改
    sortPrev(){
      if(this.index===0){
        return
      }
      let sectionPosition = JSON.parse(JSON.stringify(this.cvDetail.submodule_info.sections_position))
      let prevItem = sectionPosition[this.index-1]
      sectionPosition[this.index-1] = sectionPosition[this.index]
      sectionPosition[this.index] = prevItem

      // 调整排序
      this.positionChange(sectionPosition)
    },
    sortNext(){
      if(this.index=== this.sPosition.length-1){
        return
      }
      let sectionPosition = JSON.parse(JSON.stringify(this.cvDetail.submodule_info.sections_position))
      let nextItem = sectionPosition[this.index+1]
      sectionPosition[this.index+1] = sectionPosition[this.index]
      sectionPosition[this.index] = nextItem

      // 调整排序
      this.positionChange(sectionPosition)
    },
    async positionChange(sectionPosition) {
      let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));
      cvDetail.submodule_info.sections_position = sectionPosition;
      try {
        let data = {
          operation_type:'update_submodule_info',
          submodule_info: cvDetail.submodule_info
        }
        let res = {}
        if (this.cvDetail.basic_info.kind) {
          // this.setMenuList(this.listMenu)
          this.setCvDetail(cvDetail)
        } else  {
          if (this.$route.path.includes('mentor')) {
            res = await api.cvsEditor.updatedMentorCvInfo(this.cvToken, data)
          } else {
            res = await api.cvsEditor.updatedCvInfo(this.cvToken, data);
          }
          if (res.code === 1000) {
            //同步顺序
            this.setCvDetail(cvDetail)
            this.$message.success('更新成功');
            //同步顺序到模块管理
            // this.setMenuList(this.listMenu)
          } else {
            this.$message.error(res.message);
          }
        }
      } catch (error) {
        console.log('error=>>',error)
        this.$message.error('更新失败');
      }

    },
  },
}
</script>

<style lang="scss" scoped>
  .all-title-wrapper {
    position: relative;
    .title-operate-icon {
      display: none;
      position: absolute;
      top: 40%;
      right: 0;
      transform: translateY(-50%);
      &.left-form-icon {
        position: static;
        display: none;
        flex-direction: column;
        align-items: flex-end;
        transform: translateY(0);
        .icon-item {
          margin-right: 0;
          &:not(:last-child) {
            margin-bottom: 6px;
          }
        }
      }

      .icon-item{
        cursor: pointer;
        text-align: center;
        display: inline-block;
        width: 22px;
        height: 22px;
        background-color: #505667;
        color: #fff;
        border-radius: 4px;
        margin-right: 6px;
        text-align: center;
        font-size: 22px;
        line-height: 22px;
        &.sort-icon-prev{
          margin-right: 1px;
          border-radius: 4px 0 0 4px;
        }
        &.sort-icon-next{
          border-radius: 0 4px 4px 0;
        }
        &:last-child{
          margin-right: 0;
        }
        .iconfont {
          font-size: 22px;
          line-height: 22px;
        }
        &:hover {
          background-color: #737885;
        }
        // 禁用
        &.disabled{
          background-color: #AEB2BD !important;
          cursor: not-allowed;
        }
      }
    }
  }
</style>
